<template>
	<article class="next-payment-detail payment-receipt">
		<header>
			Estimated Payment On
			<time v-if="receipt.processedDate">{{ receipt.processedDate | date('long') }}</time>
		</header>

		<table class="table-receipt table-fixed">
			<thead>
				<tr>
					<th class="col-quantity"><acronym title="Quantity">Qty.</acronym></th>
					<th class="col-description" colspan="2">Description</th>
					<th class="col-amount">Amount</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in receipt.items"  :key="index">
					<td class="col-quantity">{{ item.quantity || 1 }}</td>
					<td class="col-description" colspan="2">{{ item.description }}</td>
					<td class="col-amount">{{ item.amount | currency }}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr class="receipt-subtotal">
					<td class="col-quantity">{{ receipt.items.length || 0 }}</td>
					<th class="col-description">Items</th>
					<th class="col-amount-label">Subtotal</th>
					<td class="col-amount">{{ receipt.subtotal | currency}}</td>
				</tr>
				<tr class="receipt-credit-tend" v-if="receipt.coupon">
					<th class="col-amount-label" colspan="3">Coupon</th>
					<td class="col-amount">{{ receipt.coupon.discount | currency}}</td>
				</tr>
				<tr class="receipt-credit-tend" v-if="receipt.tax">
					<th class="col-amount-label" colspan="3">Tax</th>
					<td class="col-amount">{{ receipt.tax | currency }}</td>
				</tr>
				<tr class="receipt-credit-tend">
					<th class="col-amount-label" colspan="3">Credit</th>
					<td class="col-amount">{{ receipt.creditTendered | currency}}</td>
				</tr>
				<tr class="receipt-payment-tend">
					<th class="col-amount-label" colspan="3">Total Due</th>
					<td class="col-amount">{{ receipt.amount | currency}}</td>
				</tr>
				<tr class="receipt-payment-tend" v-if="receipt.amount > 0 &amp;&amp; (receipt.cardBrand || receipt.cardLast4)">
					<th class="col-amount-label" colspan="3">Pay With</th>
					<td class="col-amount">{{ receipt.paymentMethod.brand }} {{ receipt.paymentMethod.Last4 }}</td>
				</tr>

				<tr class="receipt-remaining-credit">
					<th class="col-amount-label" colspan="3">Remaining Credit</th>
					<td class="col-amount">{{ receipt.remainingCredit | currency }}</td>
				</tr>
			</tfoot>
		</table>

		<footer>
			<div>(Projected {{ now | date('medium') }})</div>
		</footer>

	</article>
</template>

<script>
import date from '../filters/date';
import currency from '../filters/currency';
export default {
	name: 'ReceiptView',
	data() {
		return {
			now: new Date()
		};
	},
	filters: {
		date,
		currency
	},
	props: ['receipt']
};
</script>



// WEBPACK FOOTER //
// ./src/components/ReceiptView.vue